const adminPermissions = [
  /* 'update_depot_settings',
  'view_depot_settings',
  'update_client_settings',
  'view_client_settings', */
  'view_vehicle_utilization_threshold',
  'view_shortage_damage_settings',
  'view_detention_settings',
  'view_traffic_validation',
  'view_dateroll',
  'view_wallet_settings',
  'view_freight_charges_threshold',
  'view_document_settings',
  'view_open_indents_settings',
  'view_bids_settings',
  'view_holiday_settings',
  'view_sla_settings',
  'view_chat_settings',
  'update_chat_settings',
];

const menuIdsToExclude = [
  'freight_charges',
  'date_roll',
  'central-ho',
  'fixed_debit_config',
  'gate_pass_config',
];

const adminMenu = [{
  id: 'Admin-Depot',
  name: 'Depots setting',
  menuList: [{
    id: 'sla',
    name: 'SLA',
    putpath: 'settings/slaupdate',
    permission: 'view_sla_settings',
  },
    /* { id: 2, name: 'Material Headers', putpath: 'settings/headersupdate'},
          { id: 3, name: 'Inspection'},
          { id: 4, name: 'Business hours'},
          { id: 5, name: 'Slots'},
          { id: 6, name: 'LR Number', putpath: 'settings/lrdepotupdate'},
          { id: 7, name: 'Units', putpath: 'settings/unitupdate'},
          { id: 8, name: 'Hooks'},
          { id: 10, name: 'Notifications', putpath: 'settings/notification'}, */
  {
    id: 'non_working_days',
    name: 'Non Working Days',
    putpath: 'settings/holidaysUpdate',
    permission: 'view_holiday_settings',
  },
  {
    id: 'bid_slot',
    name: 'Bid Slot',
    putpath: 'settings/bidSettingsUpdate',
    permission: 'view_bids_settings',
  },
  {
    id: 'open_indents',
    name: 'Open Indents',
    putpath: 'settings/updateOpenIndentsCharge',
    permission: 'view_open_indents_settings',
  },
  {
    id: 'documents',
    name: 'Documents',
    permission: 'view_document_settings',
  },
  {
    id: 'freight_charges',
    name: 'Freight Charges',
    putpath: 'settings/freightChargeThresholdUpdate',
    permission: 'view_freight_charges_threshold',
  },
  {
    id: 'wallet',
    name: 'Wallet',
    putpath: 'settings/walletupdate',
    permission: 'view_wallet_settings',
  },
  {
    id: 'date_roll',
    name: 'Date Roll',
    permission: 'view_dateroll',
  },
  {
    id: 'detention',
    name: 'Detention',
    putpath: 'settings/detentionUpdate',
    permission: 'view_detention_settings',
  },
  {
    id: 20,
    name: 'Traffic Validation',
    putpath: 'order/updateTrafficValidation',
    permission: 'view_traffic_validation',
  },
  {
    id: 'central-ho',
    name: 'Central HO',
    putpath: 'settings/centralHOUpdate',
    createPath: 'settings/centralHOCreate',
    deletePath: 'settings/centralHODelete',
    permission: 'bill_to_gst_from_fcm_rcm',
  },
  {
    id: 'fixed_debit_config',
    name: 'Fixed Debit',
    putpath: 'settings/fixedDebit',
    permission: 'view_fixed_debit_settings',
  },
  {
    id: 'gate_pass_config',
    name: 'Gate Pass',
    putpath: 'settings/updateGatePassConfig',
    permission: 'view_gate_pass_settings',
  },
  {
    id: 'approvals',
    name: 'Approvals',
    putpath: 'settings/approvalsUpdate',
    permission: 'view_approvals',
  },
  {
    id: 'freight_bill_posting',
    name: 'Freight Bill Posting',
    putpath: 'settings/updateFreightBillPostingSettings',
    permission: 'view_freight_bill_posting_settings',
  },
  {
    id: 'reason_settings',
    name: 'Reason',
    putpath: 'settings/reasonSettings',
    permission: 'view_reason_settings',
  },
  ] },

{ id: 'Admin-Movement',
  name: 'Movement setting',
  menuList: [{
    id: 'shortage_damage',
    name: 'Shortage/Damage',
    putpath: 'settings/shortageDamageUpdate',
    permission: 'view_shortage_damage_settings',
  },
  {
    id: 'pay_anomaly',
    name: 'Pay Anomaly',
    putpath: 'settings/updatePayAnomaly',
    permission: 'view_pay_anomaly_settings',
    features: 'pay_anomaly_settings',
  },
  {
    id: 'chat',
    name: 'Chat',
    putpath: 'settings/chatUpdate',
    permission: 'view_chat_settings',
  },
  {
    id: 'vehicle_utilisation',
    name: 'Vehicle Utilisation',
    putpath: 'settings/setUtilizationThreshold',
    bulkPutpath: 'settings/bulkUpdateUtilizationThreshold',
    permission: 'view_vehicle_utilization_threshold',
  },
  {
    id: 'invoice',
    name: 'Invoice',
    putpath: 'settings/setDefaultBillToParty',
    permission: 'payments_v2',
  }] },
{
  id: 'Admin-Client',
  name: 'Client setting',
  menuList: [{
    id: 1,
    name: 'Dynamic Discounting Settings',
    putpath: 'settings/updateBillDiscountConfig',
    permission: 'view_discount_settings',
    // this feature should not be available
    features_exclude: 'transporter_payment_discount',
  },
  {
    id: 'static-discount-config',
    name: 'Static Discount',
    putpath: 'settings/updateStaticDiscountConfig',
    permission: 'view_static_discount',
    features: 'transporter_payment_discount',
  },
  {
    id: 'wallet-client-config',
    name: 'Wallet Configuration',
    putpath: 'settings/updateWalletConfig',
    permission: 'update_wallet_admin_settings',
    features: 'wallet_admin_settings',
  },
  {
    id: 'freight-bill-client-config',
    name: 'Freight Configuration',
    putpath: 'settings/updateFreightBillConfig',
    permission: 'update_freight_bill_admin_settings',
    features: 'freight_bill',
  },
  {
    id: 'lorry-receipt-client-config',
    name: 'Lorry Receipt Configuration',
    putpath: 'settings/updateLorryReceiptConfig',
    permission: 'update_lorry_receipt_admin_settings',
    features: 'lorry_receipt_client_settings',
  },
  {
    id: 'invoice-field-settings',
    name: 'Invoice Field Settings',
    putpath: 'settings/updateInvoiceCustomFields',
    permission: 'update_invoice_fields_settings',
    features: 'invoice_custom_fields',
  },
  {
    id: 'fap-invoice-settings',
    name: 'FAP Invoice Settings',
    putpath: 'settings/updateFapInvoiceSettings',
    permission: 'view_freight_audit_process',
    features: 'freight_audit_process',
  },
  {
    id: 'detention-client-settings',
    name: 'Detention',
    putpath: 'settings/updateClientDetention',
    permission: 'view_detention_settings',
  },
  {
    id: 'masters-approvals',
    name: 'Approvals',
    putpath: 'settings/mastersApprovalsUpdate',
    permission: 'view_approvals',
  },
  {
    id: 'masters-custom-field',
    name: 'Custom Fields',
    putpath: 'settings/mastersCustomFieldUpdate',
    permission: 'view_master_custom_fields_admin_settings',
  },
  {
    id: 'invoice-approval',
    name: 'Invoice Approval',
    putpath: 'settings/invoiceApproval',
    permission: 'view_invoice_approval_settings',
    features: 'custom_invoice_approval',
  }],
},
{
  id: 'Admin-Transporter',
  name: 'Transporter Setting',
  tlabel: 'ADMIN_TRANSPORTER_SETTINGS',
  menuList: [
    {
      id: 'insurance_threshold',
      name: 'Insurance Threshold',
      permission: 'view_insurance_threshold',
    },
    {
      id: 'transit_penalty',
      name: 'Transit Penalty',
      permission: 'view_transit_penalty',
    },
  ],
},
];

module.exports = { adminPermissions, adminMenu, menuIdsToExclude };
